import { useState } from "react";
import { ghostBtnClass, inputClass, mfgPrimaryBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";

export function PurchaseOrderArchiveDialog(props: {
  poNumber: string;
  busy: boolean;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
}) {
  const [reason, setReason] = useState("");
  const trimmed = reason.trim();
  return (
    <div className="rounded-md border border-amber-300 bg-amber-50 p-3 text-xs dark:border-amber-800 dark:bg-amber-950/40">
      <p className="font-semibold text-gray-900 dark:text-zinc-100">
        Archive PO {props.poNumber}?
      </p>
      <p className="mt-1 text-gray-600 dark:text-zinc-300">
        It leaves the open queue and stays under Archived. A reason is required.
      </p>
      <label className="mt-2 block">
        <span className="font-semibold">Reason</span>
        <textarea
          className={`${inputClass} mt-1 w-full`}
          rows={2}
          value={reason}
          disabled={props.busy}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Wrong vendor, duplicate, order cancelled…"
        />
      </label>
      <div className="mt-2 flex gap-2">
        <button
          type="button"
          className={mfgPrimaryBtnClass}
          disabled={props.busy || !trimmed}
          onClick={() => props.onConfirm(trimmed)}
        >
          {props.busy ? "Archiving…" : "Archive"}
        </button>
        <button type="button" className={ghostBtnClass} disabled={props.busy} onClick={props.onCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
}
